if (!customElements.get('grid-slider-list')) {
  customElements.define(
    'grid-slider-list',
    class GridSliderList extends HTMLElement {
      connectedCallback() {
        this.initSlider();
      }

      disconnectedCallback() {
        this.destroySlider();
      }

      destroySlider() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      initSlider() {
        this.sliderEl = this.querySelector('[data-grid-slider]');
        if (!this.sliderEl || typeof Swiper === 'undefined') return;

        const section = this.closest('.grid-slider-section');
        const prevEl = section && section.querySelector('[data-grid-slider-prev]');
        const nextEl = section && section.querySelector('[data-grid-slider-next]');
        const progressEl = section && section.querySelector('[data-grid-slider-progress]');
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const swiperOptions = {
          slidesPerView: 'auto',
          spaceBetween: 16,
          watchOverflow: true,
          a11y: true,
          keyboard: { enabled: true, onlyInViewport: true },
          navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
          pagination: progressEl ? { el: progressEl, type: 'progressbar' } : false,
        };
        if (prefersReducedMotion) swiperOptions.speed = 0;

        this.swiper = new Swiper(this.sliderEl, swiperOptions);
      }
    }
  );
}
